module.exports = __webpack_public_path__ + "img/hover_card_mantenimiento_dashboard.abacb867.svg";